import { useQuery } from 'react-query';
import { getHandbook } from '~/api/handbook';
import { useSetLanguage } from '~/hooks/i18nHooks';

export const useHandbook = () => {
  const { language } = useSetLanguage();

  return useQuery(['handbook', language], getHandbook, { staleTime: Infinity });
};
